import React, { FC, ReactNode } from 'react';
import { LinearProgress, Paper, PaperProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  loading: { height: 4 },

  tableBox: {
    marginBottom: 40,
    overflow: 'hidden',
  },

  tableBoxPagination: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '16px',
  },

  tableMain: { overflowX: 'auto' },
});

export interface TableBoxProps extends PaperProps {
  loading?: ReactNode;
  fixedTop?: ReactNode;
  fixedBottom?: ReactNode;
}

export const TableBox: FC<TableBoxProps> = ({
  loading = undefined,
  fixedTop = undefined,
  fixedBottom = undefined,
  children,
  ...other
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.tableBox} variant="outlined" {...other}>
      {fixedTop && fixedTop}

      {loading ? <LinearProgress /> : <div className={classes.loading} />}

      <div className={classes.tableMain}>{children}</div>

      {fixedBottom && <div className={classes.tableBoxPagination}>{fixedBottom}</div>}
    </Paper>
  );
};

export default TableBox;
